import { createFileRoute } from "@tanstack/react-router";

import { ContactPage } from "../contact";

export const Route = createFileRoute("/en/contact")({
	headers: () => ({
		"Cache-Control":
			"public, max-age=0, s-maxage=3600, stale-while-revalidate=86400",
	}),
	head: () => ({
		meta: [
			{ title: "Contact | Makedonijaturist AD" },
			{
				name: "description",
				content:
					"Contact Makedonijaturist AD. Information about our hotels, reservations, and business cooperation. We look forward to hearing from you.",
			},
		],
		links: [
			{
				rel: "canonical",
				href: "https://makedonijaturist.com.mk/en/contact",
			},
		],
	}),
	component: ContactPage,
});
